import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import {
    InferValuesTypes,
    Stack,
    ThemeDetails,
    ThemeAttribute,
    CourseContainerClientData,
} from '@yandex-int/k-common/typings';

import * as actions from '../library.store/actions';

export enum CONTENT_TYPES {
    STACKS = 'stacks',
    PREP_LESSONS = 'prep-lessons',
}

export interface LibraryStoreState {
    attributes: Record<number, Array<ThemeAttribute>>;
    availableAttributes: Record<number, any>;
    themesDetails: Record<number, ThemeDetails>;
    themeDetailsLoadingStatus: Record<number, LOADING_STATUSES>;
    deepLinkStack: null | Stack;
    selectedStackId: null | number;

    stacks: Record<number, Stack[]>;
    stacksLoadingStatus: LOADING_STATUSES;
    stacksLoadedPages: Record<number, number>;
    canLoadMoreStacks: Record<number, boolean>;

    stackProblemsLoadingStatus: LOADING_STATUSES;
    filterValues: Record<string, Array<string> | string>;

    coursesPreview: CourseContainerClientData[];
    coursesPreviewLoading: LOADING_STATUSES;
}

export type LibraryAction = ReturnType<InferValuesTypes<Omit<typeof actions, 'createLesson'>>>;
